import React from 'react'
import Common from '../../../Components/Layouts/Common';
import { usePermission } from '../../../Context Api/PermissionContext';
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


export const ItemCard = ({
    mainText,
    subText,
    icon,
    href,
    handler,
    requiredPermission,
    disabled = false,
}) => {
    const { hasPermission, loading } = usePermission();

    if (loading) {
        return null; // Or you could return a loading indicator
    }

    if (!hasPermission(requiredPermission)) {
        return null;
    }

    return (
        <Link
            to={href}
            className={`flex flex-col items-center ${disabled ? "cursor-not-allowed" : ""
                }`}
        >
            <div
                onClick={handler}
                className="w-24 h-24 bg-gray-100 rounded-full shadow-lg mb-4 flex justify-center items-center"
            >
             
                 <FontAwesomeIcon 
                 icon={icon}  
                 className={`${icon} text-2xl text-gray-600 ${disabled ? "opacity-50" : ""
                        }`}
                            
                            />
            </div>
            <h3
                className={`text-gray-800 font-semibold text-lg ${disabled ? "text-opacity-45" : ""
                    }`}
            >
                {mainText}
            </h3>
            <p
                className={`text-gray-500 text-sm ${disabled ? "text-opacity-45" : ""}`}
            >
                {subText}
            </p>
        </Link>
    );
};


function CityProfileManagement() {
    return (
        <div className=" bg-white  relative h-full">
            <Common headline={"City Profile Data Management"}>
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 text-center gap-6">
                    <ItemCard
                        mainText={"Basic & Indicators Data Insertion"}
                        subText="Insert Basic & Indicators Data"
                        icon={"fa-solid fa-database"} 
                        href={"/insert-basic-data"}
                        requiredPermission={"Survey"}
                    />
                    <ItemCard
                        mainText={"Map Data Insertion"}
                        subText="Insert Map Data"
                        icon={"fa-solid fa-map"}
                        href={"/insert-map-data"}
                        requiredPermission={"Survey"}
                    />
                </div>
            </Common>
        </div>
    );
};


export default CityProfileManagement